import { format, formatDistanceToNow } from 'date-fns';

// ----------------------------------------------------------------------

export function fDate(date) {
  if (date === "" || !date) {
    return format(new Date(), 'dd MMMM yyyy'); 
  }

  return format(new Date(date), 'dd MMMM yyyy');
}

export function fDateTime(date) {
  if (date === "" || !date) {
    return format(new Date(), 'dd MMM yyyy HH:mm'); 
  }

  return format(new Date(date), 'dd MMM yyyy HH:mm');
}

export function fDateTimeSuffix(date) {
  if (date === "" || !date) {
    return format(new Date(), 'dd/MM/yyyy hh:mm p'); 
  }

  return format(new Date(date), 'dd/MM/yyyy hh:mm p');
}

export function fToNow(date) {
  return formatDistanceToNow(new Date(date), {
    addSuffix: true
  });
}

export function fToInputDate(date) {
  if (date === "" || !date) {
    return format(new Date(), 'yyyy-MM-dd'); 
  }

  return format(new Date(date), 'yyyy-MM-dd');
}